export var chatMessageVariables = function chatMessageVariables(siteVars) {
  return {
    backgroundColor: siteVars.colorScheme.default.background,
    backgroundColorMine: siteVars.colorScheme.brand.background1,
    authorColor: siteVars.colorScheme.default.foreground2,
    authorFontWeight: siteVars.fontWeightRegular
  };
};
//# sourceMappingURL=chatMessageVariables.js.map
